const Footer = () => (
  <footer className="site-footer-slim">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-12 col-md-6 text-center text-md-start mb-1 mb-md-0">
          <span>
            {`© ${new Date().getFullYear()} `}
            <a
              href="https://docttorpay.com.br/"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              DocttorPay
            </a>
            {" — Todos os direitos reservados."}
          </span>
        </div>
        <div className="col-12 col-md-6 text-center text-md-end">
          <span>Gestão financeira para saúde</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
